import { useState } from 'react';
import type { MouseEvent } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TranslateIcon from '@mui/icons-material/Translate';
import { useLocale } from '@/i18n/useLocale';

const LANGUAGES: Record<string, string> = { en: 'English' };

export default function LanguageSwitcher() {
  const { language, changeLanguage } = useLocale();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  if (Object.keys(LANGUAGES).length <= 1) return null;

  return (
    <>
      <IconButton size="small" onClick={handleOpen} aria-label="Change language">
        <TranslateIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {Object.entries(LANGUAGES).map(([code, label]) => (
          <MenuItem
            key={code}
            selected={code === language}
            onClick={() => {
              void changeLanguage(code);
              handleClose();
            }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
